import { useEffect, useState } from "react";
import api from "../api/axios.tsx";

export const useExpenseByCategory = () => {
  const [transactions, setTransactions] = useState([]);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = user?.id || ""; // Fallback to "default" if no user

  useEffect(() => {
    api
      .post("/transactions/expense_summary_by_category")
      .then((response) => {
        const fetchedTransactions = response.data;
        setTransactions(fetchedTransactions);
      })
      .catch((error) => {
        console.error("Failed to fetch transactions:", error);
      });
  }, [userId]);

  return {
    transactions,
  };
};